import passengerBridge from './passenger'
import driverBridge from './driver'
import env from '../core/env'
import { initCallMethod } from './bridge.method'

let bridge

if (env.is('passenger')) {
  bridge = passengerBridge
} else if (env.is('driver')) {
  bridge = driverBridge
}

if (bridge) initCallMethod(bridge)

export default bridge
